import React, { useState, useEffect } from 'react';
import './index.css';
import { NumericFormat } from 'react-number-format';

function formatLeadingZero(value) {
    const num = parseInt(value, 10);
    return num < 10 ? `00${num}` : num < 100 ? `0${num}` : `${num}`;
}

function formatNumber(amount, decimalCount = 2, decimal = ',', thousands = '.') {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
        amount = Number(amount) || 0;

        const negativeSign = amount < 0 ? '-' : '';
        let i = parseInt(Math.abs(amount).toFixed(decimalCount)).toString();
        let j = i.length > 3 ? i.length % 3 : 0;

        return (
            negativeSign +
            (j ? i.slice(0, j) + thousands : '') +
            i.slice(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) +
            (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : '')
        );
    } catch (e) {
        console.error(e);
        return amount;
    }
}

function parseNumber(str) {
    return parseFloat(str.replace(/\./g, '').replace('.', ',')) || 0;
}

const PriceInfo = ({ label, value }) => (
    <p className="cardsap-info">
        <b>{label}: </b>
        {formatNumber(value)}
    </p>
);

const MotivoBadge = ({ motivo, precoConcorrente }) => {
    const isConcorrencia = motivo === 'CONCORRÊNCIA';
    const className = isConcorrencia ? 'bg-warning' : 'bg-info';
    const text = isConcorrencia ? `${motivo} - ${formatNumber(precoConcorrente)}` : motivo;

    return <div className={`card-text text-center ${className}`}>{text}</div>;
};

function SapCard({
    sap_loja,
    sap_data,
    sap_nomecomprador,
    sap_codigo,
    sap_descricao,
    nome,
    funcao,
    sap_custo,
    sap_preco,
    sap_precopromo,
    sap_precoapp,
    sap_precosolicitado,
    sap_motivo,
    sap_precoconcorrente,
    sap_observacao,
    sap_sequencia,
    ean,
    clickAprovar,
    clickNegar,
    onSelecionar,
    selecionado,
    onprecoEditadoChange
}) {
    // Preço local que pode ser editado
    const [precoEditado, setPrecoEditado] = useState(sap_precosolicitado);
    console.log(ean);
    // Sincroniza o precoEditado se precoSolicitado mudar (ex: quando o pai atualizar dados)
    useEffect(() => {
        setPrecoEditado(sap_precosolicitado);
    }, [sap_precosolicitado]);

    // Avisar o pai que o preço editado mudou
    // Dispara evento para o pai quando preço é alterado
    const handlePrecoChange = (event) => {
        const valor = event.target.value;
        // Permitir apenas números e ponto
        if (/^\d*\.?\d*$/.test(valor)) {
            setPrecoEditado(valor);
            if (onprecoEditadoChange) {
                const precoFloat = parseFloat(valor) || 0;
                onprecoEditadoChange(sap_loja, sap_codigo, sap_sequencia, precoFloat);
            }
        }
    };

    const handleChange = (e) => {
        onSelecionar(e.target.checked, {
            loja: sap_loja,
            codigo: sap_codigo,
            datasol: sap_data,
            sequencia: sap_sequencia,
            preco: precoEditado,
            descricao: sap_descricao
        });
    };

    function handleAprovar() {
        clickAprovar(sap_data, sap_loja, sap_sequencia, sap_codigo, sap_descricao, precoEditado);
    }

    function handleNegar() {
        clickNegar(sap_data, sap_loja, sap_sequencia, sap_codigo, sap_descricao, precoEditado);
    }

    const eanNumber = Number(ean);
    const useEAN = !isNaN(eanNumber) && eanNumber > 999999999999999;
    const query = encodeURIComponent(sap_descricao);
    const imageUrl = `https://www.google.com/search?tbm=isch&q=${query}`;

    return (
        <div className="card">
            <div className="form-check text-start m-2">
                <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selecionado}
                    onChange={handleChange}
                    id={`select-${sap_loja}-${sap_codigo}-${sap_sequencia}`}
                />
                <label className="form-check-label" htmlFor={`select-${sap_loja}-${sap_codigo}-${sap_sequencia}`}>
                    Selecionar
                </label>
            </div>

            <div className="row">
                <h2 className="cardsap-info">
                    <i className="fas fa-map-marker-alt"></i> {formatLeadingZero(sap_loja)}
                </h2>
                <h2 className="cardsap-data">
                    <i className="fa fa-calendar" aria-hidden="true"></i> {sap_data}
                </h2>
                <h2 className="cardsap-info">
                    <i className="fa fa-handshake-o" aria-hidden="true"></i> {sap_nomecomprador}
                </h2>
                <h5 className="cardsap-descricao">{sap_codigo} - {sap_descricao}</h5>

                <div className="col-12 text-center">
                    {/* Nova div para controlar o layout da imagem */}
                    <div className="cardsap-img-container">

                        <img
                            src={`https://cdn-cosmos.bluesoft.com.br/products/${ean}`}
                            alt={sap_descricao}
                            className="rounded-md"
                            onError={(e) => {
                                e.target.onerror = null;
                                // Altera para a imagem de "produto sem foto" que você já usa.
                                // A nova div e o CSS já garantem que essa imagem tenha a mesma altura
                                e.target.src = 'https://multilit.com.br/wp-content/uploads/2020/03/Produto-sem-foto.png';
                            }}
                        />
                    </div>
                </div>

                <div className="col-12 text-center">
                    <h5 className="cardsap-sol">Solicitante: {nome} - {funcao}</h5>
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-6">
                    <PriceInfo label="Custo" value={sap_custo} />
                </div>
                <div className="col-6">
                    <PriceInfo label="Preço" value={sap_preco} />
                </div>
            </div>
            <div className="row">
                <div className="col-6">
                    <PriceInfo label="Promo" value={sap_precopromo} />
                </div>
                <div className="col-6">
                    <PriceInfo label="App" value={sap_precoapp} />
                </div>
            </div>

            <div className="col-12 text-center">
                <label>Preço solicitado:</label>
                <NumericFormat
                    className="form-control preco-input text-center preco"
                    value={precoEditado}
                    onValueChange={(values) => {
                        setPrecoEditado(values.value); // valor sem separadores
                    }}
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale
                    allowNegative={false}
                />
            </div>

            <div className="text-center txt-branco">
                <div className="card-text">
                    <MotivoBadge motivo={sap_motivo} precoConcorrente={sap_precoconcorrente} />
                </div>
            </div>

            <div className="text-center">
                <div className="cardsap-detalhe">
                    <div className="card-text text-center">{sap_observacao}</div>
                </div>
            </div>

            <div className="row mt-3 px-2">
                <div className="col-6 px-1">
                    <button type="button" onClick={handleNegar} className="btn btn-danger w-100 txt-branco">
                        <i className="fa fa-thumbs-o-down fa-1x"></i> Reprovar
                    </button>
                </div>
                <div className="col-6 px-1">
                    <button type="button" onClick={handleAprovar} className="btn btn-success w-100 txt-branco">
                        <i className="fa fa-thumbs-o-up fa-1x"></i> Aprovar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SapCard;
